import React from 'react';

const questions = [
  {
    question: 'Can I use PAY888 with real funds today?',
    answer:
      'Not yet. You can create an account and explore the app preview, but deposits, card issuance, purchases and payouts are not live. Do not send funds to any sample address.',
  },
  {
    question: 'What are the card and reload fees?',
    answer:
      'Final prices are not available yet. Issuance fees, reload fees and spending limits depend on the card. Review the final quote and card terms before funding when the service becomes available.',
  },
  {
    question: 'Do I need to upload an ID?',
    answer:
      'No ID upload is required to create a PAY888 account. Card eligibility and any identity checks depend on the provider, card and country. Account registration does not guarantee card approval.',
  },
  {
    question: 'Which crypto and networks will I be able to use?',
    answer:
      'Customer crypto deposits are not included in the current free KemyCard plan. Funding is disabled. Never send cryptocurrency to a sample address or to an address intended for another asset or network.',
  },
  {
    question: 'Can I use Apple Pay, Google Pay and subscriptions?',
    answer:
      'These depend on the card, issuer, country and merchant. Not every card supports mobile wallets or recurring payments. App and brand illustrations are examples, not a guarantee of acceptance or a partnership.',
  },
  {
    question: 'What about refunds, payment links and support?',
    answer:
      'Payment links and USDT payouts are disabled in the current rollout. Refund conditions will depend on the service and provider. Live support is not available yet; public contact details and service terms still need to be finalized before a financial launch.',
  },
] as const;

export const LandingFAQ: React.FC = () => (
  <section id="faq" className="landing-faq" aria-labelledby="faq-heading">
    <div className="section-intro">
      <span className="eyebrow">GOOD TO KNOW</span>
      <h2 id="faq-heading">
        A few things,
        <br />
        before you start.
      </h2>
      <p>Clear answers about the preview and what comes next.</p>
    </div>
    <div className="faq-list">
      {questions.map(({ question, answer }) => (
        <details key={question}>
          <summary>
            {question}
            <span className="faq-indicator" aria-hidden="true">
              +
            </span>
          </summary>
          <p>{answer}</p>
        </details>
      ))}
    </div>
  </section>
);
